(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stock-counter"] && !Shopify.designMode) return;
  try {
    (function () {
    function randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function updateCounters() {
      var counters = document.querySelectorAll('[data-stock-counter]:not([data-stock-counter-ready])');

      counters.forEach(function (counter) {
        var min = parseInt(counter.getAttribute('data-min'), 10) || 1;
        var max = parseInt(counter.getAttribute('data-max'), 10) || min;
        var target = counter.querySelector('[data-stock-counter-number]');

        if (max < min) max = min;
        if (!target) return;

        target.textContent = randomBetween(min, max);
        counter.setAttribute('data-stock-counter-ready', 'true');
      });
    }

    function init() {
      updateCounters();

      document.addEventListener('shopify:section:load', updateCounters);

      var queued = false;
      var observer = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          updateCounters();
          queued = false;
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
